import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {LightButton} from '../../styles/components/button.style';
import {CommonWrapper} from './LightHomePage.style';
import {isIE11} from '../../helpers/ie.helper';

export const DishesWrapper = styled(CommonWrapper)`
  background-color: ${p => p.theme.secondaryBgColor};
`;

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  margin-top: 4rem;
  max-width: 100vw;
  ${media.medium`
    margin-top: 2rem;
    width: 100%;
    flex-wrap: wrap;
  `};
`;

const BlockBase = styled.div`
  position: relative;
  width: 26.2rem;
  height: 26.2rem;
  color: ${p => p.theme.primaryColor};
  background-size: cover;
  overflow: hidden;
  margin: 1rem;
  ${media.medium`
    flex-basis: 46%;
    height: 34rem;
  `};
  ${media.small`
    flex-basis: 100%;
    height: 34rem;
    margin: 1rem 2rem;
  `};
`;

export const Block = styled(BlockBase)`
  background: ${p => `url(${p.url}) no-repeat center center`};
  background-size: cover;
  &:hover {
    > div {
      height: 100%;
      color: ${p => p.theme.primaryColor};
      background-color: ${p => p.theme.secondaryColor};
      opacity: 0.9;
    }
    h3 {
      margin-top: 30%;
    }
  }

  ${isIE11() && `
    span {
      display: none;
    }
    
    &:hover span {
      display: inline;
    }
  `}
`;

export const SliceUp = styled.div`
  background: ${p => p.theme.primaryColor};
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 9rem;
  overflow: hidden;
  transition: height 450ms;
  color: ${p => p.theme.textColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 3rem;
  letter-spacing: 0.1rem;
  margin: 2rem 0 0.4rem;
  ${isIE11() && `
    width: 100%;
  `}
`;

export const Description = styled.span`
  font-size: 1.2rem;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 0.3rem;
  line-height: 1.4rem;
  padding: 0.6rem 1rem;
  ${isIE11() && `
    width: 100%;
  `}
`;

export const DishBlock = styled(BlockBase)`
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: ${p => p.theme.secondaryColor};
  padding: 3rem 2rem 1rem;
  font-size: 1.8rem;
  letter-spacing: 0.1rem;
  line-height: 2.8rem;
  ${media.medium`
    padding-bottom: 6rem;
  `};
`;

export const BlockBody = styled.p`
  ${isIE11() && `
    width: 100%;
  `}
`;

export const OrderNow = styled(LightButton)`
  max-height: 5rem;
  width: 17rem;
  margin: 3rem 0 2rem;
  &:hover {
    color: ${p => p.theme.secondaryColor};
  }
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/Dishes.style.js